module.exports = __webpack_public_path__ + "img/text_events_center.d344b572.png";